export * from "-!../../vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../vue-loader/lib/index.js??vue-loader-options!./Monaco.vue?vue&type=template&id=77d5ad30&"


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-monaco-editor/src/Monaco.vue?vue&type=template&id=77d5ad30&
// module id = ./node_modules/vue-monaco-editor/src/Monaco.vue?vue&type=template&id=77d5ad30&
// module chunks = 2